import { useQuery } from '@tanstack/react-query'

import { GetUnscoredCategoriesResponse } from '@appTypes/LoansApi.interface'

import { PageApiError } from '@api/utils/PageApiError'

import { handleApiResponse } from './utils/handleApiResponse'

interface Options {
    query: {
        loanAmount: number
        loanTerm: number
        mockId?: string
    }
}

export const useUnscoredCategoriesQuery = ({ query }: Options) => {
    return useQuery<GetUnscoredCategoriesResponse, PageApiError>(
        ['unscoredCategories', query.loanAmount, query.loanTerm],
        () => {
            let url = `${process.env.NEXT_PUBLIC_BASE_PATH}/api/unscored/?loanAmount=${query.loanAmount}&loanTerm=${query.loanTerm}`

            if (query.mockId) {
                url += `&mockId=${query.mockId}`
            }

            return fetch(url).then(handleApiResponse)
        },
        {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
            retry: false,
        }
    )
}
